import { MapEventBusProvider } from 'modules/space_control/contexts/workSpacesMap/MapEventBusContext'

import { WorkSpacesMapInternal } from './WorkSpacesMapInternal'
import { WorkSpacesMapProps } from './types'

export const WorkSpacesMap = (props: WorkSpacesMapProps) => {
  return (
    <MapEventBusProvider>
      <WorkSpacesMapInternal {...props} />
    </MapEventBusProvider>
  )
}
